<template>
  <div class="i-action-links" :class="{'disabled-icon' : isDisabled}">
    <template v-if="items" v-for="item in items" :key="item.pageName">
      <router-link
        v-if="!isDisabled"
        :to="goToUserDetailsPage(row.isGroup ? 'RecoveryGroupDetailsLayout' : item?.pageName, userId, siteId, teamId, classroomId, item?.dataSet)"
        @click.stop
      >
        <i-tooltip :text="row.isGroup ? 'Groups' : item.tooltipLabel" font-weight="bold" theme="dark">
          <template v-slot:tooltip-wrapper>
            <i-generate-image
              v-if="row.isGroup"
              :image="isServiceDisabled(item) ? 'icons-disabled/icons/groups.svg' : 'icons/groups.svg'"
            />
            <i-generate-image v-else :image="isServiceDisabled(item) ? 'icons-disabled/' + item?.icon : item?.icon"/>
          </template>
        </i-tooltip>
      </router-link>

      <i-tooltip v-else :text="item.tooltipLabel" font-weight="bold" theme="dark">
        <template v-slot:tooltip-wrapper>
          <i-generate-image :image="item?.icon"/>
        </template>
      </i-tooltip>
    </template>
  </div>
</template>

<script>
import ITooltip from "@/components/common/ITooltip.vue";
import IGenerateImage from "@/components/common/IGenerateImage.vue";

export default {
  name: 'IActionLinks',
  components: {IGenerateImage, ITooltip},
  props: {
    items: {
      type: Array
    },
    userId: {
      type: String
    },
    id: {
      type: String
    },
    classroomId: {
      type: String
    },
    siteId: {
      type: String
    },
    teamId: {
      type: String
    },
    dataSet: {
      type: String
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    row: {
      type: [Boolean, Array, Object]
    },
    columnItem: {
      type: Object,
    },
  },

  data() {
    return {
      collectionMap: {
        gmail: 'gMail',
      }
    }
  },

  methods: {
    isServiceDisabled(item) {
      const serviceKey = this.collectionMap[item?.collection?.toLowerCase()] || item?.collection?.toLowerCase();
      return this.columnItem?.[serviceKey]?.isDisabled || false;
    },
    goToUserDetailsPage(name, userId, siteId, teamId, classroomId, dataSet) {
      if (!this.isDisabled) {
        const params = {}
        if (dataSet) params.dataSet = dataSet
        if (userId) {
          params.userId = userId
        } else if (siteId) {
          params.siteId = siteId
        } else if (teamId) {
          params.teamId = teamId
        } else if (this.items[0].seatType === 'SharedDrive') {
          params.sharedDriveId = this.id
        } else if (this.items[0].seatType === 'Classroom') {
          params.classroomId = this.id
        } else if (this.items[0].seatType === 'SharedFolder') {
          params.sharedFolderId = this.id
        }

        return { name, params }
      }
    },
  }
}
</script>

<style lang="scss">
@import "IActionLinks";
</style>
